import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { ReservationFlowPaymentMethodListTicketBook } from 'src/interfaces/reservation_flow';
import { RSBorderedListItemCollapsible } from 'src/reservation-page/bordered-list/RSBorderedListItemCollapsible';
import { RSLinkButton } from 'src/reservation-page/RSLinkButton';

import { useDisplayBehavior } from './hooks/useDisplayBehavior';

export interface TicketBookItemNotPurchasedProps {
  onRequireTicketBookPurchasing: (productId: number) => void;
  paymentMethodsTicketBook: ReservationFlowPaymentMethodListTicketBook;
  // YYYY-MM-DD で表される今日の日付
  today: string;
  merchantTimeZone: string;
  isCollapsed: boolean;
  onRequireToggling: () => void;
  selectedDate?: string;
}

export const TicketBookItemNotPurchased: FC<
  TicketBookItemNotPurchasedProps
> = ({
  onRequireTicketBookPurchasing,
  paymentMethodsTicketBook,
  today,
  merchantTimeZone,
  isCollapsed,
  onRequireToggling,
  selectedDate,
}) => {
  const intl = useIntl();

  const { items } = useDisplayBehavior({
    today,
    merchantTimeZone,
    paymentMethodsTicketBook,
    selectedDate,
  });

  return (
    <RSBorderedListItemCollapsible
      leftContent={
        <div className="rs-font text-16 text-gray-1000 pc:text-15 font-bold">
          {intl.formatMessage({
            defaultMessage: '回数券',
            id: 'eZeb1g',
            description:
              'src/templates/merchants/resources/book/components/payment-method/TicketBookItemNotPurchased/index.tsx',
          })}
        </div>
      }
      details={
        <div className="px-2.5 py-3">
          <ul className="list-style-none m-0 space-y-2.5 p-0">
            {items.map(({ product }) => {
              return (
                <li
                  key={`paymentMethod_ticketBook_products_${product.public_id}`}
                  className="block"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex flex-auto items-center justify-between">
                      <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
                        {product.name}
                      </div>
                      <div className="rs-font text-13 text-gray-1000 pc:text-12 whitespace-nowrap font-normal">
                        {intl.formatNumber(product.price, {
                          style: 'currency',
                          currency: 'JPY',
                        })}
                      </div>
                    </div>

                    <div className="rs-font text-16 pc:text-15 ml-1.5 flex-none font-normal">
                      <RSLinkButton
                        type="button"
                        onClick={() =>
                          onRequireTicketBookPurchasing(product.public_id)
                        }
                      >
                        {intl.formatMessage({
                          defaultMessage: '購入',
                          id: 'vGuJRU',
                          description:
                            'src/templates/merchants/resources/book/components/payment-method/TicketBookItemNotPurchased/index.tsx',
                        })}
                      </RSLinkButton>
                    </div>
                  </div>

                  <div className="rs-font text-13 text-gray-1000 pc:text-12 mt-0.5 font-normal">
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          '利用可能数：{totalCount} / 有効期限：{expirationMonth}ヶ月',
                        id: 'QDK/vw',
                        description:
                          'src/templates/merchants/resources/book/components/payment-method/TicketBookItemNotPurchased/index.tsx',
                      },
                      {
                        totalCount: product.total_count,
                        expirationMonth: product.expiration_month,
                      },
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      }
      isCollapsed={isCollapsed}
      isSelected={false}
      onClick={onRequireToggling}
      data-rsv-ticket-book="not-purchased"
    />
  );
};
